'use es6';

import { fromJS } from 'immutable';
export const defaultScatterSeriesOptions = fromJS({
  marker: {
    symbol: 'circle',
    radius: 5
  }
});